<template>
    <el-dialog :title="isEdit?'信息详情':'信息详情'" 
        :visible.sync="dialogForm" 
        width="1000px"
        append-to-body
        :close-on-click-modal="false">
        <el-form
            :inline="true"
            :model="form"
            class="search-form"
            label-width="100px"
            ref="aList">
            <el-row>
                <el-col :span="24" style="margin-bottom:0.2px">
                    <el-form-item label="发件人：" prop="concatMan">
                        {{form.senderName}}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="isEdit">
                    <el-form-item label="接收时间：" prop="concatMan">
                        {{form.sendTime}}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="!isEdit">
                    <el-form-item label="发件时间：" prop="concatMan">
                        {{form.createDateTime}}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="!isEdit">
                    <el-form-item label="消息类型：" prop="concatMan">
                        {{form.messageType | _filterMessageType}}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="!isEdit">
                    <el-form-item label="收件人" prop="resourceName">
                        <span style="width: 800px;max-height: 200px;overflow: auto;text-overflow: ellipsis;white-space: normal;display: inline-block;">
                            {{form.recipientList?form.recipientList.join(','):''}}
                        </span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="内容" prop="resourceName">
                        <editor ref="content" v-model="form.content" v-if="form.subType!='1'"></editor>
                        <el-button type="primary" v-if="form.subType=='1'" @click="CKPDFWJ">查看PDF文件</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="dialog-footer" style="text-align:center;margin-top:20px;">
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { getCustomerList,setBatchRead,getRollMessage } from '@/api/system/person'
    import { REG_PHONE,REG_EMAIL,REG_NUM_CODE } from "@/utils/Reg";
    import autoSearchCustom from '@/components/autocomplete/autoSearchCustom'
    import editor from '@/components/editor'
    export default {
        name: 'outChargesDetailForm',
        components: {
            autoSearchCustom,editor
        },
        data() {
            return {
                form: this.clearForm(),
                isEdit: false,
                dialogForm: false,
                innerVisible: false,
                gridData: [],
            }
        },
        mounted() {
             console.log("$serverUrl",this.$serverUrl)
        },
        methods: {
            clearForm() {
                return {}
            },
            cancel(){
                this.dialogForm = false
                this.form = {}
            },
            loadData(row) {
                this.$nextTick(() => {

                    console.info("传过来的数据",row);

                    this.form = row
                    this.$refs.content.content = row.content
                    this.$forceUpdate()
                    if(this.isEdit) {
                        let param = {
                            idList: row.messageId
                        }
                        // 进入页面标为已读
                        setBatchRead(param).then(res => {
                            //this.loadData()
                            this.$emit('load')
                            // 顶部header数据刷新
                            getRollMessage().then(res => {
                                this.$store.commit('SET_MESSAGE_LIST', res.data)
                            })
                        })
                    }
                })
            },
            CKPDFWJ(){
                // window.open("http://106.91.213.226:18089"+this.form.content);
                //window.open("http://www.cqppl.com:8189"+this.form.content);

                let serverUrl = this.$serverUrl
                window.open(serverUrl+this.form.content);
                

            }
        },
        watch: {
            dialogForm(bull) {
                if(!bull) {
                    this.$refs.aList.clearValidate();
                    this.form = this.clearForm()
                }
            }
        }
    }

</script>

<style scoped>
.el-checkbox {
    margin-right: 30px;
    margin-left: 0;
}
.tab-type {
    border: 1px solid #ccc;
    padding: 4px 10px;
    border-radius: 4px;
    cursor: pointer;
}
.active {
    background-color: #009aff;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/business/system/newsDetail.vue